;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.videoLightbox = (function () {
    const ytUrlRE = /^.*(v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/

    function setupYoutubeLightboxes () {
      const trigger = $('body').find('[data-toggle="modal"]')
      const $modal = $('#video__modal')
      const $iframe = $modal.find('iframe')

      const removeSrc = () => $iframe.removeAttr('src')

      $modal.find('button.close').click(removeSrc)
      $modal.on('hide.bs.modal', removeSrc)
      $modal.on('hidden.bs.modal', removeSrc)

      trigger.click(function (e) {
        e.preventDefault()
        const videoSRC = $(this).attr('href')
        const youtubeCheck = videoSRC.match(ytUrlRE)
        const youtubeID = (youtubeCheck && youtubeCheck.length > 2) && youtubeCheck[ 2 ]
        const videoSRCauto = youtubeID ? (`//www.youtube.com/embed/${youtubeID}?badge=0&autoplay=1&html5=1`) : videoSRC
        $iframe.attr('src', videoSRCauto)
      })
    }

    function init () {
      setupYoutubeLightboxes()
    }

    return {
      init: init
    }
  }())

  $(document).ready(function () {
    GCO.videoLightbox.init()
  })
}(jQuery, window))
